import * as React from 'react';
import ScreenContentWrapper from './ScreenContentWrapper';
export default function DebugContainer(props) {
  return /*#__PURE__*/React.createElement(ScreenContentWrapper, props);
}
//# sourceMappingURL=DebugContainer.web.js.map